export const endpoint = {
  case: 'case',
  casePermissions: 'case/access',
  bowtieSupported: 'case/bowtie/supported',
  favouriteReport: 'case/report/favourite',
  ui: 'case/ui',
  riskMatrix: 'matrixDefinition/risk',
  surveyManagerSupported: 'case/surveymanager/supported',
  riskEvaluationSupported: 'case/riskEvaluation/supported',
  loadLayoutTypes: (reportId: number) =>
    `favourite/definition/draft/report/${reportId}/layouttype/options`,
  defaultIncludedFields: (reportId: number) =>
    `/report/${reportId}/includedFields/default`,
  additionalIncludedFields: `/favourite/definition/draft/casereport/includedfields`
};

export const caseListingTranslation = {
  search_hits: 7474,
  search_no_hits: 7548,
  case_deleted_success: 7472,
  toggle_info_description: 7759,
  toggle_info_subtitle: 7760,
  toggle_info_title: 7761,
  toggle_info_load_options: 7762,
  execute_failed_info_description: 8331,
  text_page_of: 8454,
  text_open_bowtie: 8632,
  text_bowtie_not_supported: 8642,
  text_load_more_cases_text: 9841,
  text_more_cases_exist_print: 9842
};
